<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.to"
            link
            class="pl-8"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.to" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { fetchIsConfigured } from '@/services/meetReportService';

export default {
  data: () => ({
    meetEnabled: false,
    items: [
      {
        icon: 'mdi-cash-multiple',
        text: 'Financial',
        to: { name: 'Invoices' },
      },
      {
        icon: 'mdi-file-account-outline',
        text: 'Client Statement',
        to: { name: 'ClientStatement' },
      },
      {
        icon: 'mdi-cash-clock',
        text: 'Payments',
        to: { name: 'Payments' },
      },
      {
        icon: 'mdi-account-check-outline',
        text: 'Enrollments',
        to: { name: 'Enrollment' },
      },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Attendance',
        model: false,
        children: [
          {
            icon: 'mdi-clipboard-text',
            text: 'Attendance Sheet',
            to: { name: 'Attendance' },
          },
          {
            icon: 'mdi-calendar-month',
            text: 'Monthly Attendance',
            to: { name: 'MonthlyAttendance' },
          },
          {
            icon: 'mdi-chart-bar',
            text: 'Executive Summary',
            to: { name: 'AttendanceExecutiveSummary' },
          },
        ],
      },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Checklists',
        model: false,
        children: [
          {
            icon: 'mdi-checkbox-multiple-marked',
            text: 'Daily Summary',
            to: { name: 'ChecklistDailySummary' },
          },
          {
            icon: 'mdi-checkbox-multiple-marked',
            text: 'Student Summary',
            to: { name: 'ChecklistStudentSummary' },
          },
          {
            icon: 'mdi-checkbox-multiple-marked',
            text: 'Executive Summary',
            to: { name: 'ExecutiveChecklistSummary' },
          },
        ],
      },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Google Meet',
        model: false,
        meetGated: true,
        children: [
          {
            icon: 'mdi-video-check',
            text: 'Session Audit',
            to: { name: 'MeetSessionAudit' },
          },
          {
            icon: 'mdi-account-star',
            text: 'Tutor Performance',
            to: { name: 'MeetTutorPerformance' },
          },
        ],
      },
      {
        icon: 'mdi-note-check-outline',
        text: 'Test Prep',
        to: { name: 'TestPrep' },
      },
      {
        icon: 'mdi-account-multiple',
        text: 'Contacts',
        to: { name: 'contact' },
      },
      {
        icon: 'mdi-file-chart',
        text: 'Staff Timesheet',
        to: { name: 'Timesheet' },
      },
      {
        icon: 'mdi-cash-clock',
        text: 'Payroll And Scheduling',
        to: { name: 'PayrollAndScheduling' },
      },
      {
        icon: 'mdi-tools',
        text: 'Account Closing',
        to: { name: 'accountClosing' },
      },
      {
        icon: 'mdi-stethoscope',
        text: 'Data Health',
        to: { name: 'DataHealth' },
      },
    ],
  }),

  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser', 'userRoles']),
    ...mapGetters('navigation', ['navState']),
    displayableItems() {
      const allRoutes = this.$router.options.routes;

      const isRouteAuthorized = (routeName) => {
        const route = allRoutes.find((r) => r.name == routeName);
        if (route && route.meta) {
          return this.isLoggedIn && this.isAuthorized(route.meta.authorize);
        } else if (!route) {
          return false;
        }
        return true;
      };

      return this.items.filter((item) => {
        if (item.meetGated && !this.meetEnabled) return false;
        if (item.children) {
          return item.children.some((child) =>
            isRouteAuthorized(child.to.name),
          );
        }
        return isRouteAuthorized(item.to.name);
      });
    },
  },
  async mounted() {
    try {
      this.meetEnabled = await fetchIsConfigured();
    } catch {
      this.meetEnabled = false;
    }
  },
  methods: {
    ...mapActions('messages', ['addErrorMessage']),
    isAuthorized(roles) {
      if (!roles || roles.length < 1) {
        return true;
      }
      if (this.userRoles && this.userRoles.length > 0) {
        return this.userRoles.some((r) => roles.includes(r));
      } else {
        this.addErrorMessage('Unauthorized Access');
        return false;
      }
    },
  },
};
</script>

<style></style>
